export default __webpack_public_path__ + "static/media/en_notification.55fd20ee.mp3";